module.exports = __webpack_public_path__ + "static/media/1.0 mr tan.8a615eea.png";